import { c as _c } from "react/compiler-runtime";
import { fetchAdChatConfig, fetchChatChannelUserList, fetchChatTranslate, fetchSaveAdChat, fetchSupporterChatNotice, freezeChatRoom, postChatMessage } from '@module/apis/client-side/chat';
import type { AdChatResponse, FetchAdChatParams, FetchChatChannelUserListParams, FetchChatChannelUserListResponse, FetchChatTranslateParams, FetchChatTranslateResponse, FetchSupporterChatNoticeParams, FetchSupporterChatNoticeResponse, FreezeChatRoomParams, FreezeChatRoomResponse, PostChatMessageParams, PostChatMessageResponse, SaveAdChatParams } from '@module/apis/client-side/chat/type';
import type { ApiBaseResponse } from '@module/apis/type';
import { type UseMutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../type';
import { chatQueryKeys } from './chatQueryKeys';
export const useChatMessageMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = chatQueryKeys.postChatMessage();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useFreezeChatRoomMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = chatQueryKeys.freezeChatRoom();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp2,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useFetchChatChannelUserLisQuery = (fetchChatChannelUserListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchChatChannelUserListParams) {
    t0 = chatQueryKeys.fetchChatChannelUserList(fetchChatChannelUserListParams);
    $[0] = fetchChatChannelUserListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchChatChannelUserListParams) {
    t1 = () => fetchChatChannelUserList(fetchChatChannelUserListParams);
    $[2] = fetchChatChannelUserListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useAdChatConfigQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = chatQueryKeys.fetchAdChatConfig(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = () => fetchAdChatConfig(params);
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      staleTime: Infinity,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useSaveAdChatMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = chatQueryKeys.fetchSaveAdChat();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp3,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useFetchChatTranslateMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = chatQueryKeys.fetchChatTranslate();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp4,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useFetchSupporterChatNoticeQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = chatQueryKeys.fetchSupporterChatNotice(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = () => fetchSupporterChatNotice(params);
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
function _temp(postChatMessageParams) {
  return postChatMessage(postChatMessageParams);
}
function _temp2(freezeChatRoomParams) {
  return freezeChatRoom(freezeChatRoomParams);
}
function _temp3(saveAdChatParams) {
  return fetchSaveAdChat(saveAdChatParams);
}
function _temp4(fetchChatTranslateParams) {
  return fetchChatTranslate(fetchChatTranslateParams);
}